import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import InvoicesList from "./pages/InvoicesList";
import InvoiceForm from "./pages/InvoiceForm";
import InvoiceDetail from "./pages/InvoiceDetail";
import Settings from "./pages/Settings";
import Subcontractors from "./pages/Subcontractors";
import Submissions from "./pages/Submissions";
import { Toaster } from "./components/ui/sonner";

const AppShell = ({ children, adminOnly = false }) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <>
                  <Login />
                  <Toaster />
                </>
              }
            />
            <Route path="/" element={<AppShell><Dashboard /></AppShell>} />
            <Route path="/invoices" element={<AppShell><InvoicesList /></AppShell>} />
            <Route path="/invoices/new" element={<AppShell><InvoiceForm /></AppShell>} />
            <Route path="/invoices/:id" element={<AppShell><InvoiceDetail /></AppShell>} />
            <Route path="/invoices/:id/edit" element={<AppShell><InvoiceForm /></AppShell>} />
            <Route path="/settings" element={<AppShell><Settings /></AppShell>} />
            <Route
              path="/subcontractors"
              element={<AppShell adminOnly><Subcontractors /></AppShell>}
            />
            <Route
              path="/submissions"
              element={<AppShell adminOnly><Submissions /></AppShell>}
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
